export default {

    apiUrl: 'https://heppy.gekophaken.nl/api',
    oauthAuthorizeUrl: 'https://heppy.gekophaken.nl/api/oauth/authorize',
    oauthRedirectUrl: 'https://heppy.gekophaken.nl/api/inloggen',
}